declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
  }
}

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

function getCookie(name: string): string | undefined {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : undefined;
}

async function sendServerEvent(params: {
  event_name: string;
  event_id: string;
  custom_data?: Record<string, unknown>;
}) {
  try {
    const { event_name, event_id, custom_data } = params;
    await fetch(`${SUPABASE_URL}/functions/v1/meta-capi`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': SUPABASE_ANON_KEY,
      },
      body: JSON.stringify({
        event_name,
        event_id,
        event_time: Math.floor(Date.now() / 1000),
        event_source_url: window.location.href,
        user_data: {
          fbp: getCookie('_fbp'),
          fbc: getCookie('_fbc'),
        },
        custom_data,
      }),
    });
  } catch (err) {
    console.warn('Meta CAPI send failed:', err);
  }
}

export const trackPageView = () => {
  const eventId = crypto.randomUUID();
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'PageView', {}, { eventID: eventId });
  }
  sendServerEvent({ event_name: 'PageView', event_id: eventId });
};

export const trackInitiateCheckout = () => {
  const eventId = crypto.randomUUID();
  const customData = {
    content_name: 'AutoMake - Camilla Felix',
    content_category: 'Curso de Automaquiagem',
    value: 197.00,
    currency: 'BRL',
  };
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'InitiateCheckout', customData, { eventID: eventId });
  }
  sendServerEvent({ event_name: 'InitiateCheckout', event_id: eventId, custom_data: customData });
};

export const openCheckout = () => {
  trackInitiateCheckout();
  window.open('https://pay.kiwify.com.br/e5qjnSu', '_blank');
};
